import Footer from '../components/Footer';
import Header from '../components/Header';
import View from '../components/View';

const ViewPostPage = () => {
   return (
      <div>
         <Header />
         <View />
         <Footer />
      </div>
   );
};

export default ViewPostPage;
